/* eslint-disable max-lines-per-function */
import Styles from './PreToPostSubsPopup.module.scss';
import React, { JSX } from 'react';

const PreToPostSubsPopup = ({
  onClose,
  content,
  prepaid,
}: any): JSX.Element => {
  const login = () => {
    onClose();
  };

  const showOffers = () => {
    window.location.href =
      content?.buttonBloks?.[1]?.button?.[0].buttonLink?.url ??
      content?.buttonBloks?.[0]?.button?.[0].buttonLink?.url;
  };

  return (
    <>
      <div className={Styles.modalContainer}>
        <div className={Styles.headerTitle}>{content?.title.content?.[0]?.content?.[0]?.text}</div>
        <div className={`${Styles.paragraphtext}`}>
          <p className='mb-4'>{content?.title?.content?.[1]?.content?.[0]?.text}</p>
        </div>
        <hr className={`${Styles.seperator1}`} />

        {!prepaid ? (
          <div className={`${Styles.buttongroup} `}>
            <div className={`${Styles.labelgroup} `}>
              <label className={`${Styles.label}`}>{content?.buttonBloks?.[0]?.text}</label>
              <button className={`${Styles.buttonVariantNew} ${Styles.login}`} onClick={login}>
                {content?.buttonBloks?.[0]?.button?.[0].buttonLabel}{' '}
                <img src={content?.buttonBloks?.[0]?.button?.[0]?.buttonIcon?.filename} alt='button'/>
              </button>
            </div>
            <div className={`${Styles.labelgroup} `}>
              <label className={`${Styles.label}`}>{content?.buttonBloks?.[1]?.text}</label>
              <button
                className={`${Styles.buttonVariantNew} ${Styles.offers}`}
                onClick={showOffers}
              >
                {content?.buttonBloks?.[1]?.button?.[0].buttonLabel}
                <img src={content?.buttonBloks?.[1]?.button?.[0]?.buttonIcon?.filename} alt='button'/>
              </button>
            </div>
          </div>
        ) : (
          <div className={`${Styles.buttongroup} `}>
            <div className={`${Styles.labelgroupNew} `}>
              <label className={`${Styles.label}`}>{content.buttonBloks?.[0]?.text}</label>
              <button
                className={`${Styles.buttonVariantNew} ${Styles.offers}`}
                onClick={showOffers}
              >
                {/* button text  */}
                {content.buttonBloks?.[0]?.button?.[0].buttonLabel}
                <img src={content.buttonBloks?.[0]?.button?.[0]?.buttonIcon?.filename}  alt='button'/>
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default PreToPostSubsPopup;
